export default "__VITE_ASSET__2mgMUB$F__"